import { Store, configureStore } from "@reduxjs/toolkit";
import { articleSlice } from "./slices/Article/ArticleSlice";
import { commentSlice } from "./slices/Comment/CommentSlice";
import { contentSlice } from "./slices/Content/ContentSlice";
import { dashboardSlice } from "./slices/Dashboard/DashboardSlice";
import { dialogSlice } from "./slices/Dialog/DialogSlice";
import { routesSlice } from "./slices/DynamicRoutesSlice/DynamicRoutesSlice";
import { menuSlice } from "./slices/Menu/MenuSlice";
import { pageSlice } from "./slices/Page/PageSlice";
import { quizSlice } from "./slices/Quiz/QuizSlice";

export const store: Store = configureStore({
  reducer: {
    content: contentSlice.reducer,
    article: articleSlice.reducer,
    dialog: dialogSlice.reducer,
    comment: commentSlice.reducer,
    menu: menuSlice.reducer,
    quiz: quizSlice.reducer,
    page: pageSlice.reducer,
    dashboard: dashboardSlice.reducer,
    routes: routesSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
